import { Box, Container, Grid, Typography } from '@mui/material';
import { SectionTitleFontSize } from '../HomeView';

const AiHighlightSection = () => {
  return (
    <Box sx={{ py: 8 }}>
      <Container maxWidth="lg">
        <Grid container spacing={4} alignItems="center">
          {/* Text Content */}
          <Grid item xs={12} md={6}>
            <Typography
              variant="h4"
              fontWeight={700}
              gutterBottom
              fontSize={SectionTitleFontSize}
            >
              Meet S3G AI
            </Typography>
            <Typography variant="body1" color="textSecondary">
              S3G AI is our intelligent, organization-aware assistant integrated
              directly into your management dashboard. It provides instant
              support, streamlines operations, and offers proactive insights to
              keep your team informed and efficient. Experience a new level of
              management and operational excellence.
            </Typography>
          </Grid>
          {/* Visual Element */}
          <Grid item xs={12} md={6} sx={{ textAlign: 'center' }}>
            <Box
              component="img"
              src="/ai-preview.gif"
              alt="AI assistant in action"
              sx={{
                width: '100%',
                maxWidth: 500,
                borderRadius: 2,
                boxShadow: 3,
              }}
            />
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default AiHighlightSection;
